import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import ProductServiceForm from "../../../Components/Forms/Pages/Product/ProductServiceForm";
import DrawerContext from "../../../Context/DrawerContext";
import {
    addProductService,
    connectProduct,
    getProductServiceList
} from "../../../Services/Product/ProductServiceService";
import LinearProgress from '@mui/material/LinearProgress';
import { getUnits, getCurrencies, getTaxRatesSelectOptions } from '../../../Util/SiteDataUtil';
import SnackbarContext from "../../../Context/SnackbarContext";
import {getProductServiceCategoryList} from "../../../Services/Product/ProductServiceCategoryService";
import {addDocument} from "../../../Services/DocumentManagement/DocumentService";
import {getSizeDescription} from "../../../Util/FileUtil";
import referenceType from "../../../Constants/DocumentManagement/ReferenceType";
import {getWooCommerceSettings} from "../../../Services/Product/ProductSettingsService/WooCommerceSettingsService";


const formRules = {
    'name': {required: true}, 'publicName': {required: true},
    'price': {required: true}, 'tax': {required: true}, 
    'currency': {required: true}, 'unit': {required: true},
    'type': {required: true},
}

const AddProductService = (props) => {

    const siteData = useSelector((state) => state.siteData)
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm();
    const {data, control, watch, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [productServiceCategory, setProductServiceCategory] = useState([])
    const connect = watch("connect");
    const [enabled,setEnabled] = useState(false);
    const auth = useSelector((state) => state.auth);



    useEffect(() => {
        setDrawerTitle(strings.pages.product.productService.addProductService.pageTitle);
    });

    useEffect( () => {
        fetchCategory()
    },[])

    useEffect(() => {
        setValue('connect', connect);
        fetchEnabled();
    }, [connect,enabled]);

    const fetchEnabled = () => {
        getWooCommerceSettings(auth.company.id).then(response => {
            if(!response || !response.ok){
                return;
            }
            setEnabled(response.data.entity.enabled);
        });

    }

    const fetchCategory = () => {
        getProductServiceCategoryList({}).then(response => {
            if (!response || !response.ok) {
                return;
            }
            setProductServiceCategory(response.data.result);
        })
    }

    const onSubmit = (data) => {
        const images = getValues('images');
        data['images'] = null;

        setShowLoader(true);

        addProductService(data).then(response => {
            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorAdding, 'error');
                props.onFinish();
                return;
            }

            if(images) {
                let files = images.getAll('images');
                let result = {};


                for (let file of files) {
                    result.name = file.name;
                    result.file = file;

                    const docData = {
                        ...result,
                        referenceId: response.data.entity.id,
                        referenceType: referenceType.PRODUCT_SERVICE,
                        documentSize: getSizeDescription(result.file.size).replace(/[()]/g, '')
                    }

                    addDocument(docData).then(response => {

                        if (!response || !response.ok) {
                            showMessage(strings.commonMessages.errorAdding, 'error');
                            if (strings.error.DocumentHandler[response.response.data.message]) {
                                showMessage(strings.error.DocumentHandler[response.response.data.message], 'error');
                            }
                            props.onFinish();
                            return response;
                        }

                        showMessage(strings.commonMessages.addingSuccessful, 'success');
                        props.onFinish();
                    });
                }
            }
            setShowLoader(false);
            props.onFinish();

            if(connect && enabled) {
                connectProduct(response.data.entity).then(response => {
                    if (!response || !response.ok) {
                        showMessage('error');
                        }
                        props.onFinish();
                        return response;
                })
            }
            showMessage(strings.commonMessages.addingSuccessful, 'success');
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <ProductServiceForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                currencies={getCurrencies(siteData)}
                units={ getUnits(siteData) }
                taxesOptions={ getTaxRatesSelectOptions(siteData) }
                errors={errors} data={data} form={form} control={control}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}
                productServiceCategory={productServiceCategory}
                watch={watch}
                connect={connect} setConnect={setValue}/>
        </Paper>
    </div>
}

export default AddProductService;